function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.7425 3.09L17.2125 5.03L18.1225 8.09L15.4925 6.28L12.8625 8.09L13.7725 5.03L11.2425 3.09L14.4325 3L15.4925 0L16.5525 3L19.7425 3.09ZM16.9625 14.95C17.7925 14.87 18.6825 16.05 18.1525 16.8C17.8325 17.25 17.4925 17.67 17.0725 18.07C13.1625 22 6.8325 22 2.9325 18.07C-0.9775 14.17 -0.9775 7.83 2.9325 3.93C3.3325 3.53 3.7525 3.17 4.2025 2.85C4.9525 2.32 6.1325 3.21 6.0525 4.04C5.7825 6.9 6.7425 9.87 8.9425 12.06C9.98211 13.1052 11.2408 13.9066 12.6277 14.4064C14.0146 14.9062 15.4951 15.0918 16.9625 14.95ZM17.1825 16.5C14.5 16.5 10.591 15.0675 8.5 13C6.33 10.81 4.66 6.86 4.5 4.04C-0.5 8.09 0.49 14.48 3.5 17.5C6.52 20.51 13 21.5 17.1825 16.5Z",
  fill: "#4678EC"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/moon.35be8a35.svg";
export { SvgComponent as ReactComponent };